export interface SearchContainerConfig {
    input: HTMLInputElement;
    container: HTMLElement;
}

export class SearchContainer {
    protected isActive: boolean = false;
    private readonly elements: {
        input: HTMLInputElement;
        container: HTMLElement;
    };
    protected isOpened: boolean;


    constructor({input, container}: SearchContainerConfig) {
        this.elements = {input, container};
        this.init();
    }

    protected setWidth(): void {
        const {container} = this.elements;

        if (window.innerWidth < 1100) {
            this.isActive
                ? container.style.width = `auto`
                : container.style.width = `100%`;
            this.isActive = !this.isActive;
        }
    }

    protected init(): void {
        const {input, container} = this.elements;
        if (!input || !container) return;

        input.addEventListener('focus', () => this.setWidth());
        input.addEventListener('blur', () => this.setWidth());
    }
}